import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_BANKS_INIT_ACTION,
  FETCH_BANKS_SUCCESS_ACTION,
  FETCH_BANKS_FAIL_ACTION,
  ADD_BANK_INIT_ACTION,
  ADD_BANK_SUCCESS_ACTION,
  ADD_BANK_FAIL_ACTION,
  EDIT_BANK_INIT_ACTION,
  EDIT_BANK_SUCCESS_ACTION,
  EDIT_BANK_FAIL_ACTION,
  FETCH_BANK_SEARCH_INIT_ACTION,
  FETCH_BANK_SEARCH_SUCCESS_ACTION,
  FETCH_BANK_SEARCH_FAIL_ACTION,
} from "./action";
//import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchBanks(value) {
  let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/bankName?limit=10&page=` + pageno, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_BANKS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_BANKS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* AddBank(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.name,
      code: value.value.code,
      desc: value.value.desc,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/bankName`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_BANKS_INIT_ACTION });
      yield put({
        type: ADD_BANK_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Bank added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_BANK_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* EditBank(value) {
  try {
    const token = localStorage.getItem("token");
    console.log("active " + value.value.isActive);
    const data = {
      name: value.value.name,
      code: value.value.code,
      desc: value.value.desc,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/bankName/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_BANKS_INIT_ACTION });
      yield put({
        type: EDIT_BANK_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Bank updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_BANK_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* bankSearch(value) {

  let searchVal = value.value.searchBank
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/bankName?limit=10&page=` + value.value.Spage + `&search=` + searchVal,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_BANK_SEARCH_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_BANK_SEARCH_FAIL_ACTION, error: err });
    } else {
    }
  }
}



export function* BankActionWatcher() {
  yield takeEvery(FETCH_BANKS_INIT_ACTION, fetchBanks);
  yield takeEvery(ADD_BANK_INIT_ACTION, AddBank);
  yield takeEvery(EDIT_BANK_INIT_ACTION, EditBank);
  yield takeEvery(FETCH_BANK_SEARCH_INIT_ACTION, bankSearch);
}
